export enum WeightUnit {
  KILOGRAM = 'KILOGRAM',
  POUND = 'POUND',
  SHORT_TON = 'SHORT_TON',
  LONG_TON = 'LONG_TON',
}
